var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left-panel h-100"},[_c('h3',{staticClass:"text-center div_title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"container-form ck-content",domProps:{"innerHTML":_vm._s(_vm.infosContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }